// extracted by mini-css-extract-plugin
export default {"container":"oSNoFs","divider":"QsIK1j","stack":"kiSwNI"};